import React, { useState } from "react";
import styles from "./CreateProduct.module.sass";
import Card from "../../../components/Card";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import { UseApi } from "../../../hooks/use-api";
import Modal from "../../../components/Modal";
import Body from "./body";
import cn from "classnames";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import { useUser } from "../../../context";
import Confirm from "../../../components/Confirm";
import { CreateRaffle, RaffleUpdate } from "../../../Services/lib/nfttemplates";
import Loader from "../../../components/Loader";
import raffle from "../../../i11/Raffle";

const CreateProduct = ({ close, editData, getData }) => {
	const { locale } = useUser();
	const [isAuction, setAuction] = useState();
	const [local, setLocal] = useState();
	const [save, setSave] = useState(false);

	const { onOpen, onClose, isOpen } = UseDisclosure();

	const [{ isLoading }, upload] = UseApi({
		service: CreateRaffle,
		successMsg: raffle[locale].success,
	});

	const [{ isLoading: updateLoading }, update] = UseApi({
		service: RaffleUpdate,
		successMsg: raffle[locale].success,
	});
	const check_ = () => {
		if (!local.prizes) {
			ToastEmitter({
				type: "info",
				msg: raffle[locale].pls_prizes,
			});
			return;
		}
		if (!local.criterians) {
			ToastEmitter({
				type: "info",
				msg: raffle[locale].pls_criterians,
			});
			return;
		}
		return true;
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		const res = check_();
		if (!res) return;

		onOpen();
	};

	const onConfirm = async () => {
		if (editData) {
			delete local.brand;
			local.status = save ? "DRAFT" : "OPEN";
			const res = await update(local);
			if (res) {
				close();
				getData();
			}
		} else {
			local.status = "OPEN";
			const res = await upload(local);
			if (res) {
				close();
				getData();
			}
		}
	};
	return (
		<Card
			className={styles.card}
			title={
				editData ? raffle[locale].edit_raffle : raffle[locale].c_raffle
			}
			classTitle="title-green"
		>
			<form onSubmit={handleSubmit}>
				<Body
					setLocal={setLocal}
					local={local}
					isAuction={isAuction}
					setAuction={setAuction}
					editData={editData}
				/>
				<div className={styles.foot}>
					{!editData && (
						<button
							disabled={isLoading}
							onClick={async () => {
								const next = check_();
								if (!next) return;
								const res = await upload(local);
								if (res) {
									close();
									getData();
								}
							}}
							className={cn("button button-stroke")}
						>
							{isLoading && <Loader />}
							{raffle[locale].s_draft}
						</button>
					)}
					{editData && (
						<button
							type="submit"
							className={cn("button")}
							onClick={() => setSave(true)}
						>
							{editData.status === "OPEN"
								? raffle[locale].s_draft
								: raffle[locale].save}
						</button>
					)}
					<button
						type="submit"
						className={cn("button")}
						onClick={() => setSave(false)}
					>
						{raffle[locale].publish}
					</button>
				</div>
			</form>
			<Modal visible={isOpen} onClose={onClose}>
				<Confirm
					title={raffle[locale].l_publish}
					onCancel={onClose}
					onConfirm={onConfirm}
					isLoading={isLoading || updateLoading}
				></Confirm>
			</Modal>
		</Card>
	);
};

export default CreateProduct;
